import authTypes from "./auth.authTypes";
export default {
  signupLoading: state => state.type === authTypes.SIGNUP_REQUEST,
  signupSuccess: state => state.type === authTypes.SIGNUP_SUCCESS,
  sendConfirmationLoading: state => state.type === authTypes.SEND_CONFIRMATION_CODE_REQUEST,
  loginLoading: state => state.type === authTypes.LOGIN_REQUEST
};
